<template>
    <md-field class="select bordered" :class="{ 'md-invalid': hasError, 'md-has-value': hasValue || searchFieldFocused }">
        <label :for="id" v-html="label"></label>
        <vue-select
            :id="id"
            :options="options"
            :reduce="entity => typeof entity === 'object' ? entity.value : entity"
            :clearable="false"
            :searchable="searchable"
            :multiple="multiple"
            v-model="selectedValue"
            @change="emitChange"
            @search:focus="onSearchFieldFocus"
            @search:blur="onSearchFieldBlur"
        >
            <template #open-indicator="{ attributes }">
                <i v-bind="attributes" class="fal fa-chevron-down"></i>
            </template>
            <template #no-options="{ search, searching, loading }">
                Keine Auswahlmöglichkeiten vorhanden.
            </template>
        </vue-select>
        <span class="md-error" v-if="hasError" v-html="errorMessage"></span>
        <input type="hidden" :name="name" :value="selectedValue">
    </md-field>
</template>

<script>
import VueSelect from 'vue-select/src/index';

export default {
  name: 'IoShopSelect',

  emits: [
    'input',
    'onOption:selected',
    'onOption:selecting',
  ],

  components: {
    VueSelect,
  },

  model: {
    prop: 'old',
    event: 'input',
  },

  watch: {
    selectedValue() {
      this.emitChange();
    },
  },

  props: {
    old: {
      required: false,
      default: () => null,
    },
    name: {
      type: String,
      required: false,
      default: () => null,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      required: false,
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    forceSelection: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    searchable: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    error: {
      type: [String, Object],
      required: false,
      default: () => '',
    },
  },

  data() {
    return {
      id: `ioi-${Math.random().toString(36).substr(2, 9)}`,
      selectedValue: this.old,
      searchFieldFocused: false,
    };
  },

  computed: {
    hasValue() {
      if (this.selectedValue === null) return false;

      switch (typeof this.selectedValue) {
        case 'string':
          return this.selectedValue.trim() !== '';
          break;
        case 'object':
          return this.selectedValue.length >= 1;
          break;
      }

      return true;
    },
    hasError() {
      return this.error !== null;
    },
    errorMessage() {
      return this.error !== null ? (
        Array.isArray(this.error) ? (
          this.error.length > 0 ? this.error[0] : ''
        ) : this.error
      ) : '';
    },
  },

  methods: {
    emitChange() {
      this.$emit('input', this.selectedValue);
    },
    onSearchFieldFocus() {
      this.searchFieldFocused = true;
    },
    onSearchFieldBlur() {
      this.searchFieldFocused = false;
    },
  },

  updated() {
    if (this.forceSelection && this.options.length) {
      const hasOldOption = this.options.filter(({ value }) => value === this.old).length;

      if (!hasOldOption) {
        this.selectedValue = this.options[0].value;
      }
    }
  },

  mounted() {
    this.$emit('input', this.selectedValue);
  },
};
</script>

<style lang="scss">
    @import "~vue-select/dist/vue-select.css";

    .select {
        > .v-select {
            .vs__dropdown-toggle {
                padding: 0;
                border: 2px solid #DBDBDB;
                border-radius: 5px 5px 0 0;

                .vs__selected-options {
                    padding: 0;
                }

                .vs__actions {
                    padding: 0 16px 0 0;
                }
            }

            .vs__selected, .vs__search {
                padding: 7px 0 !important;
                border: 0;
                background: transparent;
                line-height: 1.25;
                margin: 0;
                outline: 0;
            }

            &:not(.vs--open) {
                .vs__dropdown-toggle {
                    border-radius: 5px 5px 5px 5px;
                }
                .vs__selected {
                    + .vs__search {
                        position: absolute;
                    }
                }
            }

            > ul {
                margin: -2px 0 0 0;
                border: 2px solid #DBDBDB;

                > li {
                    padding: 8px 16px !important;
                    font-weight: 600 !important;
                }
            }
        }
    }
</style>
